export default __webpack_public_path__ + "static/media/ICI_Intercity_investment_Dark2.cce3c71d.png";